<script>
import { HMIS_USERNAME } from "@/plugins/vars";
export default {
    name: "UnauthorizedAccess",

    methods: {

        logOut() {

            window.Cookies.remove(HMIS_USERNAME);
            window.Cookies.remove("P_102");
            window.localStorage.removeItem("P_102");
            window.location.replace('/login');
        },
    }
}
</script>
<template>
    <div class="flex flex-col w-full">
        <div class="flex-1 flex justify-center p-2">
            <img class="text-center" style="height:30%; width:30%" src="/403.svg" alt="403">
        </div>
        <div class="flex-1 flex justify-center p-2">
            <h3 class="text-center font-bold text-red-600 text-5xl">Access Denied</h3>
        </div>
        <div class="flex-1 flex justify-center p-2">
            <router-link class="font-bold btn-primary" to="/"><i class="fa fa-home"></i> Go Back home</router-link>
        </div>
        <div class="flex-1 flex justify-center p-2">
            <button class="btn-danger font-bold"
                @click.prevent="logOut"
            >Log Out</button>
        </div>
    </div>
</template>
